<template>
  <div :data-testid="getTestId('admin-reports-page')">
    <SolarExamineReportCrudTable :data-testid="getTestId('admin-reports-table')" />
  </div>
</template>

<script>
import { getTestId } from '@/utils/testUtils';

export default {
  name: 'SolarExamineReport',
  components: {
    SolarExamineReportCrudTable: () => import('../../components/table/SolarExamineReportCrudTable.vue')
  },
  methods: {
    getTestId(testId) {
      return getTestId(testId);
    }
  }
};
</script>
